import React, {Component} from 'react';
import "../css/Login.css";
import {Link, useNavigate} from "react-router-dom";
import logo from "../assets/logo_espol_blanco.svg";
import {Alert} from 'react-bootstrap';
import axios from 'axios';
import equis from "../assets/eliminar.svg";
import info from "../assets/Info.png";
import Modal from './components/Modal';
//import AdminUsuarios from './AdminUsuarios';
import Cookies from 'js-cookie';
import { useLocation, Navigate } from "react-router-dom";
import withRouter from "../routes/withRouter";

// const navigate = useNavigate();

export class Login extends Component{    
    
    constructor(props) {

        super(props);

        this.state = {
            datosUsuario:{
                correo: "",
                password: ""
            },
            alert:{
                show:false,
                titulo:"",
                mensaje:"",
                variante:""
            },
			modal:{
                show:false,
                titulo:"",
                mensaje:"",
                imagen:""
            },
            expresiones:{
                correo:/^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}([/.]\w{2,})?$/,
            },
            errorSolicitud:{
                correo:"",
                password:"",
            },
            redirectTo: null
        };
        this.cerrarAlert=this.cerrarAlert.bind(this);
		
		this.abrirModal=this.abrirModal.bind(this);
        this.cerrarModal=this.cerrarModal.bind(this);
    }
	
	abrirModal(){
        this.setState({
            modal:{
                ...this.state.modal,
                show:true
            }
        });
    }

    cerrarModal(){
        this.setState({
            modal:{
                titulo:"",
                mensaje:"",
                imagen:"",
                show:false
            }
        });
        //console.log("cerrar modal "+this.state.modal);
    }
	
	
    handlerLogin=async(e)=>{
        await this.setState({
            datosUsuario:{
                ...this.state.datosUsuario,
                [e.target.name]:e.target.value,
            }
        })
        //console.log(this.state.datosUsuario);
        this.handlerOnBlur();

    }

    handlerOnBlur=async()=>{

        /*if(this.state.datosUsuario.correo===""){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                correo: "El campo 'Correo' es requerido"
            }})
        }else */
        if(!this.state.expresiones.correo.test(this.state.datosUsuario.correo)){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                correo: "El campo 'Correo' no tiene formato correcto"
            }})
        }else{
            this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                correo:""
            }})
        }

        if(this.state.datosUsuario.password===""){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                password: "El campo 'Contraseña' es requerido"
            }})
        }else{
            this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                password:""
            }})
        }

    }

    iniciarSesion=async(e)=>{
        e.preventDefault();

        const { correo, password } = this.state.datosUsuario;

        if (correo === "" || password === "") {
            this.setState({
                alert: {
                    show: true,
                    titulo: "Error en la solicitud",
                    mensaje: "Campos vacíos",
                    variante: "danger"
                }
            });
            return;
        }

        const credenciales = { email: correo, password };
        
        try {
            const r = await axios.post(`${process.env.REACT_APP_API_EXT}/Account/InicioSesion`, credenciales);
            if (r.data.status.isSuccessfully) {
                Cookies.set('token', r.data.data.jwtToken, { expires: 1, secure: true });
                Cookies.set('DatosPersonalesGIA.CAS', 'Logeado Alternativo', { expires: 1 });

                const nextPath = this.props.location.state?.from || "/inicio";
                this.setState({ redirectTo: nextPath });
            } else {
                this.setState({
                    modal: {
                        show: true,
                        titulo: "ATENCIÓN",
                        mensaje: (
                            <span className='olvContra-mdl-text' align="justify">
                                No existe una cuenta externa creada con ese correo electrónico. Regístrese aquí: {" "}
                                <a href="/registro"><i>Crear Cuenta</i></a>
                            </span>
                        ),
                        imagen: info,
                    }
                });
            }
        } catch (error) {
            this.setState({
                modal: {
                    show: true,
                    titulo: "Error en la solicitud",
                    mensaje: "Correo o contraseña incorrecta",
                    imagen: equis
                }
            });
        }
    }

    setearHeader(){
        //console.log("setear header");
        var token = JSON.parse(Cookies.get("token"));
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            axios.defaults.headers.common['Authorization'] = null;

        }

    }

    cerrarAlert(){
        this.setState({show:false})
    }    

    render(){
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />;
        }

        return(

            // this.state.showRenderAdminUser? <Navigate to="/usuarios"/>:
            <div className="container-fluid" id="fondo">

                
                {
                    this.state.show&&
                    <Alert variant={this.state.alert.variante} onClose={this.cerrarAlert} dismissible>
                        <Alert.Heading>{this.state.alert.titulo}</Alert.Heading>
                        <p>
                        {this.state.alert.mensaje}.
                        </p>
                    </Alert>
                }


                <div className="login-wrapper">
                    <div className="login-container" >
                    
                        <div className='login-header'>
                            <img className='logo' src={logo} alt="Logo espol" ></img>
                        </div>                        
                        <div className="login-body">
                            <div className="containerIniciarSesion">
                                <button 
                                type="button" 
                                className="btn-submit-login"
                                onClick={() => this.props.navigate("/iniciar-sesion")}
                                >
                                    INICIAR SESIÓN MICROSOFT
                                </button>      
                                <button 
                                type="button" 
                                className="btn-submit-login"
                                onClick={() => this.props.navigate("/login-google")}
                                >
                                    INICIAR SESIÓN GOOGLE
                                </button>        
                                <p className='mt-4'>¿Eres nuevo? <Link className="link" to="/registro">Regístrate</Link></p>
                                <p className='mt-4'><Link className="link" to="/cambiarContrasenia">Cambiar contraseña</Link></p>
                            </div>
                        </div>
						
						{this.state.modal.show&& 
                        <Modal isOpen={this.state.modal.show} cerrarModal={this.cerrarModal} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>{this.state.modal.titulo}</strong></p>
                            <div className='mt-6 mb-6'>
                                <img className="registroContra-check" src={this.state.modal.imagen} alt="Error"></img>
                            </div>

                            <p className='text-center'>{this.state.modal.mensaje}</p>
                            
                        </Modal>}
						
                        <div className="linea"></div>

                    </div>                             
                </div>
            </div>
            
            
        )
    }
}

export default withRouter(Login);

